import { differenceInHours } from "date-fns";
import { UserAccount } from "src/types/User";

export default function isRejectionRecent(user: UserAccount): boolean {
  if (user.applicationStatus !== "rejected") {
    return false;
  }
  if (process.env.NODE_ENV === "development") {
    return false;
  }

  if (!user.applicationStatusLastUpdatedAt) {
    return false;
  }

  const rejectionTime = new Date(user.applicationStatusLastUpdatedAt);
  const now = new Date();
  const hoursSinceRejection = differenceInHours(now, rejectionTime);

  // Return false for future timestamps (negative hours)
  if (hoursSinceRejection < 0) {
    return false;
  }

  return hoursSinceRejection < 12;
}
